import React, { ReactElement } from "react";
import styled from "styled-components";
import { Layout } from "antd";
import { Logo } from "icons";
import { theme } from "theme/theme";

const { Footer } = Layout;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  margin: 0 auto;
`;

const WrapperLogo = styled.div`
  position: absolute;
  top: 38px;
  transform: translateX(50%);
  ${theme.media.tablet} {
    top: 80px;
    position: unset;
    transform: unset;
    text-align: center;
    margin-bottom: 32px;
    margin-top: 80px;
  }
`;

const WrapperContent = styled.div`
  position: relative;
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  width: 300px;
  padding: 32px 16px;
  margin-top: 90px;
  ${theme.media.mobileM} {
    width: 343px;
  }
  ${theme.media.tablet} {
    margin-top: 0px;
    width: 450px;
    padding: 32px 40px;
  }
`;

const CopyRight = styled.div(({ theme }) => ({
  color: theme.colors.border,
  fontSize: theme.sizes.xs,
  fontWeight: theme.fontWeight.medium,
}));

const FooterStyled = styled(Footer)`
  text-align: center;
  width: 100%;
  bottom: 0;
  padding: 16px 0;
  margin-top: 80px;
  ${theme.media.desktop} {
    padding: 24px 0;
  }
`;

const SpecialLayout: React.FC = ({ children }): ReactElement => {
  return (
    <Wrapper>
      <Container>
        <WrapperLogo>
          <Logo width={166} height={28} />
        </WrapperLogo>
        <WrapperContent>{children}</WrapperContent>
      </Container>
      <FooterStyled>
        <CopyRight>© LEBER, Inc. All Rights Reserved.</CopyRight>
      </FooterStyled>
    </Wrapper>
  );
};

export default SpecialLayout;
